import type { IHeroBlockProps } from "./HeroBlock.props";
import { HeroBackgroundImage } from "../../../../modules/hero/components/HeroBackgroundImage/HeroBackgroundImage";
import { HeroSplitImage } from "../../../../modules/hero/components/HeroSplitImage/HeroSplitImage";

export const HeroBlock = (props: IHeroBlockProps) => {
  if (!props.image) {
    return null;
  }

  if (props.variant === "split-image") {
    return <HeroSplitImage {...props} />;
  }

  return <HeroBackgroundImage {...props} />;
};

HeroBlock.displayName = "Block::HeroBlock";
